import axios from "axios";
import webConfig from "@/global.config"
// import { reject } from "core-js/fn/promise";
import router from "./router";
import lan from './lang/i18n'

let request= axios.create({
    baseURL:process.env.VUE_APP_API_URL,
    // timeout:30*1000,
})

request.interceptors.request.use((config)=>{
    let whiteList= webConfig.whiteListApi
    let url=config.url
    let token=localStorage.getItem('token');
    if(whiteList.indexOf(url)===-1&&token){
        config.headers.token=token;
    }
    let language=localStorage.getItem('user-lang');
    if(language){
        // if(language=='zh')
        // {
        //     config.headers.language='zh-cn';
        // }
        // else
        // {
        //     config.headers.language=language;
        // }
        config.headers.language=language;
    }
    return config;
},error=>{
    return Promise.reject(new Error(error))
})

request.interceptors.response.use((res)=>{
    const status=res.data.code||200
    const message= res.data.message||"未知错误";
    if(status===404){
        alert("没有权限")
        router.push('/error404')
        return Promise.reject(new Error(message))
    }
    if(status===404){
        alert("系统错误")
        return Promise.reject(new Error(message))
    }
    return res.data;
},error=>{
    alert(error)
    return Promise.reject(new Error(error))
})

export default request